import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
// import { Wrapper, Status } from "@googlemaps/react-wrapper";
import { GoogleMap, LoadScript, Marker } from '@react-google-maps/api';
import {
  Grid,
  Theme,
  Button,
  Divider,
  Typography,
  DialogContent,
  DialogContentText,
  Dialog,
  DialogActions,
  DialogTitle
} from '@material-ui/core';
import LocationOn from '@material-ui/icons/LocationOn';
import { ErrorOutline, CheckCircleOutline } from '@material-ui/icons';
import { useRecoilState } from 'recoil';
import { btnColor, mainBlueColor } from '../GlobalState';
import { makeStyles, createStyles } from '@material-ui/core/styles';
import MapMarkerModal from './MapMarkerModal';
import { Span } from '@sentry/tracing';
import { red } from '@material-ui/core/colors';
import { ROLE } from '../const/Const';

export interface mapProps {
  latitude: number;
  longitude: number;
  setLatitude: Dispatch<SetStateAction<number>>;
  setLongitude: Dispatch<SetStateAction<number>>;
  convertToLatLng: (force?: boolean) => Promise<any>;
  isMarkerChecked: boolean;
  setIsMarkerChecked: Dispatch<SetStateAction<boolean>>;
  userRoleId?: number;
}

export const ConstructSiteMap: React.FC<mapProps> = ({
  latitude,
  longitude,
  setLatitude,
  setLongitude,
  convertToLatLng,
  isMarkerChecked,
  setIsMarkerChecked,
  userRoleId
}) => {
  const [mainColor] = useRecoilState(mainBlueColor);
  const [buttonColor] = useRecoilState(btnColor);
  const useStyles = makeStyles((theme: Theme) =>
    createStyles({
      subContainer: {
        marginLeft: 15,
        alignItems: 'center',
        display: 'flex',
        flexDirection: 'row'
      },
      textMainContainer: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '50%',
        minHeight: 60,
        alignItems: 'center'
      },
      inputMainContainer: {
        display: 'flex',
        backgroundColor: '#F5F5F5',
        minHeight: 60,
        alignItems: 'center',
        width: '100%'
      },
      refButton: {
        color: '#fff'
      },
      map: {
        paddingTop: 0,
        paddingLeft: 10,
        paddingRight: 10
      },
      textMapMainContainer: {
        display: 'flex',
        backgroundColor: mainColor,
        width: '20%',
        minHeight: 240,
        alignItems: 'center'
      },
      textMapContainer: {
        marginLeft: 15,
        color: '#FFFFFF',
        fontSize: 14
      },
      inputMapMainContainer: {
        backgroundColor: '#F5F5F5',
        minHeight: 240,
        alignItems: 'center',
        width: '80%'
      },
      inputMapSubContainer: {
        minHeight: 120
      },
      mapButton: {
        paddingLeft: 30,
        paddingRight: 30,
        marginTop: 10,
        marginLeft: 10,
        color: '#fff',
        '&:hover': {
          color: '#fff'
        }
      },
      mapSubLink: {
        display: 'inline-block',
        margin: 10
      }
    })
  );
  const classes = useStyles();

  const [modalOpen, setModalOpen] = useState(false);

  return (
    <Grid container justify={'center'}>
      <div className={classes.subContainer} style={{ marginBottom: 15 }}>
        <div className={classes.textMapMainContainer}>
          <div className={classes.textMapContainer}>地図</div>
        </div>
        <div className={classes.inputMapMainContainer}>
          <div className={classes.inputMapSubContainer}>
            <Button
              className={classes.mapButton}
              variant='contained'
              style={{
                textTransform: 'none',
                backgroundColor: buttonColor
              }}
              target='_blank'
              rel='noopener noreferrer'
              href={`https://www.google.com/maps?q=${latitude},${longitude}`}
            >
              GoogleMapで見る
            </Button>
            {userRoleId != ROLE['OUTSIDE_PARTNER'] && (
              <>
                <Button
                  className={classes.mapButton}
                  variant='contained'
                  style={{
                    textTransform: 'none',
                    backgroundColor: buttonColor
                  }}
                  onClick={() => {
                    setModalOpen(true);
                  }}
                >
                  ピンの位置を調節する
                </Button>
                {isMarkerChecked ? (
                  <span style={{ color: '#8AC75A', padding: 8 }}>
                    <CheckCircleOutline />
                    ピン確認済
                  </span>
                ) : (
                  <span style={{ color: '#FFCC33', padding: 8 }}>
                    <ErrorOutline />
                    ピン未確認
                  </span>
                )}
              </>
            )}
          </div>
          <Divider style={{ backgroundColor: '#CCCCCC' }} />
          <div className={classes.inputMapSubContainer}>
            <span style={{ marginLeft: 10, marginBottom: 12 }}>
              付近を検索：
            </span>
            <a
              className={classes.mapSubLink}
              target='_blank'
              rel='noopener noreferrer'
              href={`https://www.google.com/maps/search/コンビニ/@${latitude},${longitude},16z`}
            >
              コンビニ
            </a>
            <a
              className={classes.mapSubLink}
              target='_blank'
              rel='noopener noreferrer'
              href={`https://www.google.com/maps/search/トイレ/@${latitude},${longitude},16z`}
            >
              トイレ
            </a>
            <a
              className={classes.mapSubLink}
              target='_blank'
              rel='noopener noreferrer'
              href={`https://www.google.com/maps/search/駐車場/@${latitude},${longitude},16z`}
            >
              駐車場
            </a>
            <a
              className={classes.mapSubLink}
              target='_blank'
              rel='noopener noreferrer'
              href={`https://www.google.com/maps/search/ホームセンター/@${latitude},${longitude},16z`}
            >
              ホームセンター
            </a>
            <a
              className={classes.mapSubLink}
              target='_blank'
              rel='noopener noreferrer'
              href={`https://www.google.com/maps/search/金物屋/@${latitude},${longitude},16z`}
            >
              金物屋
            </a>
          </div>
        </div>
      </div>
      <MapMarkerModal
        latitude={latitude}
        longitude={longitude}
        setLatitude={setLatitude}
        setLongitude={setLongitude}
        convertToLatLng={convertToLatLng}
        isMarkerChecked={isMarkerChecked}
        setIsMarkerChecked={setIsMarkerChecked}
        modalOpen={modalOpen}
        setModalOpen={setModalOpen}
      />
    </Grid>
  );
};
